export default {
  slug: 'intelligence-search',
  title: 'Search & enrichment',
  description: 'Run enrichment, read results, and manage search history.',
  section: 'intelligence',
  order: 1,
  tags: ['search', 'enrichment', 'async'],
  body: `# Search & enrichment

The intelligence search module runs **in-house enrichment** on a single observable as part of Hivemind Subterfuge Platform.

## Supported input types

The engine auto-detects:

- IPv4 / IPv6 addresses
- Domains and URLs (including panel URLs)
- Email addresses
- Phone numbers
- Usernames and Telegram handles
- Crypto wallets and wallet tags
- File hashes

Paste any value into **[Intelligence → Search](/intelligence/search)** and submit.

## Async vs sync

By default searches run **asynchronously** via Celery. The result page polls until status is \`complete\` or \`failed\`.

| Status | Meaning |
|--------|---------|
| \`pending\` | Queued |
| \`running\` | Enrichment in progress |
| \`complete\` | All sections finished |
| \`failed\` | Error recorded in \`error_message\` |

## Reading results

Each search opens an entity detail page with tabs:

1. **Summary** — input, normalized value, type, risk score, status
2. **Enrichment** — one card per enrichment section (IP info, geolocation, DNS, WHOIS, etc.)
3. **Relationships** — linked cases, indicators, and manual links
4. **Raw** — full JSON payload for export or ticketing

## Search history

**[Intelligence → History](/intelligence/history)** lists past runs. Click any row to reopen the result page and pivot from there.

## Promote to indicator

From the result sidebar or header, choose **Promote**:

1. Optionally select a **case** to attach the new indicator
2. Set **confidence** (low / medium / high)
3. Confirm — the platform creates an \`HdpIndicator\` and \`EntityLink\` rows (\`promoted_from\`, \`observed_in\`)

Promoted indicators retain \`metadata.search_query_id\` so enrichment can be viewed from the indicator detail page.

## Tips

- Re-run enrichment from an indicator detail page via **Run enrichment** (starts a new search on the indicator value).
- High-cardinality inputs (long URLs) normalize before enrichment — check the **Normalized** field if results look unexpected.
`,
};
